import { render, staticRenderFns } from "./cModalFichaProvider.vue?vue&type=template&id=555979a8"
import script from "./cModalFichaProvider.vue?vue&type=script&lang=js"
export * from "./cModalFichaProvider.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./cModalFichaProvider.vue?vue&type=custom&index=0&blockType=SweetAlert&%3Aswal=swal&ref=SweetAlert"
if (typeof block0 === 'function') block0(component)

export default component.exports